<template>
  <div class="customer-goal">
    <div class="titulo">
      <h1>Certo, vamos ao seu cadastro</h1>
      <p>O Padmoney oferece soluções em pagamentos para todos os tipos de necessidade</p>
    </div>
    <Options @select="selectHandler">
      <a value="cpf" class="option card-box" @click="$emit('change', 'PF')">
        <span class="icon">
          <img src="@/assets/img/icone-pessoa-fisica.png" alt="">
        </span>
        <span class="text">
          <p>Pessoa Física</p>
        </span>
      </a>
      <a value="cnpj" class="option card-box" @click="$emit('change', 'PJ')">
        <span class="icon">
          <img src="@/assets/img/icone-pessoa-juridica.png" alt="">
        </span>
        <span class="text">
          <p>Pessoa Jurídica</p>
        </span>
      </a>
    </Options>
  </div>
</template>

<script>
import Options from '@/components/options/Options'
import Option  from '@/components/options/Option'
import Info    from '@/components/Info'

export default {
  name: 'PersonType',
  components: {
    Info,
    Option,
    Options
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String
  },
  methods: {
    selectHandler(value) {
      this.$emit('change', value)
    }
  }
}
</script>
